import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"];

  connect() {
    this.inputTarget.addEventListener("input", this.round.bind(this));
  }

  round(event) {
    const value = event.target.value;
    const pattern = new RegExp(`\\.(\\d{3,})$`);

    if (pattern.test(value)) {
      const roundedValue = parseFloat(value).toFixed(2);
      event.target.value = roundedValue
    }
  }
}
